module.exports = __webpack_public_path__ + "static/media/non-tax.8676a165.png";